// @flow
import { TravelsActionTypes } from './constants';

type TravelsAction = { type: string, payload: {} | string };

// common success
export const travelsApiResponseSuccess = (actionType: string, data: any): TravelsAction => ({
    type: TravelsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const travelsApiResponseError = (actionType: string, error: string): TravelsAction => ({
    type: TravelsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getTravel = (id: string): TravelsAction => ({
    type: TravelsActionTypes.GET_TRAVEL,
    payload: { id },
});

export const addTravel = (travel:any):TravelsAction=>({
    type:TravelsActionTypes.ADD_TRAVEL,
    payload:travel
})
export const updateTravel = (travel:any):TravelsAction=>({
    type:TravelsActionTypes.UPDATE_TRAVEL,
    payload:travel
})
export const deleteTravel = (id:string):TravelsAction=>({
    type:TravelsActionTypes.DELETE_TRAVEL,
    payload:{id}
})

export const listTravels = (params:any): TravelsAction => ({
    type: TravelsActionTypes.LIST_TRAVELS,
    payload: params,
});

export const setFiltersTravels = (params:any): TravelsAction => ({
    type: TravelsActionTypes.SET_FILTER,
    payload: params,
})

export const resetTravels = (): TravelsAction => ({
    type: TravelsActionTypes.RESET,
    payload: {},
});

